import { reportErrorAPI } from "./reportErrorAPI";
import { takeScreenshot } from "./takeScreenshot";

export const reportError = async (
    id,
    name,
    url,
    subject,
    description,
    screenshotFn = takeScreenshot,
    reportFn = reportErrorAPI
) => {

    try {

        const blob = await screenshotFn();
        const formData = new FormData();
        formData.append('contentId', id);
        formData.append('contentTitle', name);
        formData.append('contentUrl', url);
        formData.append('errorSubject', subject);
        formData.append('errorBody', description);
        formData.append('file', blob);

        const response = await reportFn(formData);
        return response;

    } catch (error) {
        return false;
    }
};